export default __webpack_public_path__ + "static/dacs06-c2b97b718b8158945d01bc9b9ab75692.jpg";